import React, { useEffect, useState } from 'react';
import { DiscoveryService } from '../DiscoveryService';
import { DiscoverySearchLogs } from '../../../model/discovery/DiscoverySearchLogs';
import { Card, Table } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { formatDate } from '../../../utils/Functions';
import { DiscoverySearchFilter } from './DiscoverySearchFilter';
import { ErrorToast } from '../../../utils/toasters';
import TableLayout from '../../../shared/layout/table/TableLayout';
import { ITableColumn } from '../../../shared/components/TableSkeleton';

const DISCOVERY_SEARCH_COLUMNS: ITableColumn[] = [
    { label: 'Date' },
    { label: 'User' },
    { label: 'Campaign' },
    { label: 'Tokens' },
    { label: 'Action' },
];

export function DiscoverySearch() {
    const [discovery, setDiscovery] = useState<DiscoverySearchLogs[]>([]);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [dataLoading, setDataLoading] = useState(true);
    const [change, setChange] = useState<boolean>(false);
    const [state, setState] = useState({
        page: 1,
        perPage: 15,
        userId: undefined,
        campaignId: undefined,
        companyId: undefined,
    });

    useEffect(() => {
        let isCurrent = true;
        setDataLoading(true);

        DiscoveryService.getDiscoverySearchLogs(state)
            .then(res => {
                if (!isCurrent) return;
                setDiscovery(res.data);
                setTotalPages(Math.ceil(res.count / state.perPage));
            })
            .catch(err => {
                if (isCurrent) ErrorToast(err);
            })
            .finally(() => {
                if (isCurrent) setDataLoading(false);
            });

        return () => {
            isCurrent = false;
        };
    }, [change]);

    function handleClick() {
        setChange(!change);
        setState({
            ...state,
            page: 1,
        });
    }

    const handlePages = (updatePage: number) => {
        setState({ ...state, page: updatePage });
        setChange(!change);
    };

    function handleChange(evt: any) {
        const value = evt?.target?.value ? evt.target.value : undefined;
        setState({
            ...state,
            [evt.target.name]: value,
        });
    }

    return (
        <>
            <Card
                className="mb-5 p-4"
                onKeyDown={e => {
                    if (e.key === 'Enter') handleClick();
                }}
            >
                <DiscoverySearchFilter handleClicks={handleClick} handleChanges={handleChange} />
            </Card>
            <TableLayout
                pagination={{ page: state.page, totalPages }}
                listLength={discovery.length}
                handlePages={handlePages}
                isLoading={dataLoading}
                dataName="search logs"
                skeletonColumns={DISCOVERY_SEARCH_COLUMNS}
                skeletonRows={state.perPage}
            >
                <Table hover responsive>
                    <thead>
                        <tr>
                            {DISCOVERY_SEARCH_COLUMNS.map(column => (
                                <th key={column.label} className={column.className}>
                                    {column.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {discovery.map(e => (
                            <tr key={e?.id}>
                                <td>{formatDate(e?.createdAt)}</td>
                                <td>
                                    <span className="text-primary">({e?.user?.id})</span> {e?.user?.firstName ?? '-'}{' '}
                                    {e?.user?.lastName}
                                </td>
                                <td>
                                    {e?.campaign?.title ? (
                                        <>
                                            <span className="text-primary">({e.campaign.id})</span> {e.campaign.title}
                                        </>
                                    ) : (
                                        <span className="word-break text-danger">
                                            <FaTimes />
                                        </span>
                                    )}
                                </td>
                                <td>{e?.amount}</td>
                                <td></td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </TableLayout>
        </>
    );
}
